import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Link } from "react-router-dom";
import Api from "../../Hooks/Api";
const ProductsReport = (props) => {
  const [state, setState] = useState([]);
  const [responsemessage, setresponsemessage] = useState("");
  const [regionsOptions, setRegionsOptions] = useState([]);
  const [countiesOptions, setCountiesOptions] = useState([]);
  const [inputs, setInputs] = useState({});
  const [statusOptions, setStatusOptions] = useState([]);
  const fetchCounties = async (regionId) => {
    try {
      Api.get("/api/counties/" + regionId)
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setCountiesOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const loadData = async () => {
    let countyId = inputs.countyId;
    if (countyId === undefined || countyId === "") {
      countyId = 0;
    }
    let regionId = inputs.regionId;
    if (regionId === undefined || regionId === "") {
      regionId = 0;
    }
    let statusId = inputs.statusId;
    if (statusId === undefined || statusId === "") {
      statusId = 0;
    }
    fetchData(regionId, countyId, statusId);
  };
  const handleInputChange = (event) => {
    const { name, type, value, checked } = event.target;
    const inputValue = type === "checkbox" ? checked : value;

    setInputs((inputs) => ({
      ...inputs,
      [name]: ["categoryId", "statusId", "wardId"].includes(name)
        ? parseInt(inputValue, 10)
        : inputValue,
    }));

    if (name === "regionId") {
      fetchCounties(inputValue);
    }
  };
  const fetchRegions = async () => {
    try {
      Api.get("/api/regions/getAll")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setRegionsOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const convertTimestampToDate = (timeStamp) => {
    return new Date(timeStamp).toLocaleDateString("en-US");
  };

  const fetchData = (regionId, countyId, statusId) => {
    setresponsemessage("");
    setState([]);

    let url =
      "api/reports/products?regionId=" +
      regionId +
      "&countyId=" +
      countyId +
      "&statusId=" +
      statusId;

    Api.get(url)
      .then(function (response) {
        if (response.data.length == 0) {
          setresponsemessage("No data found");
        }
        setState(response.data);
      })
      .catch(function (error) {})
      .then(function () {
        // always executed
      });
  };
  const fetchProductStatus = async () => {
    try {
      Api.get("/api/productStatus/getAll?page=0&size=1000")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setStatusOptions(data.productStatus);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    fetchData(0, 0, 0);
    fetchRegions();
    fetchProductStatus();
  }, []);

  const MyComponentToPrint = React.forwardRef((props, ref) => (
    <div className="row" ref={ref}>
      <div className="col-sm-12">
        <h5 className="text-center">Ministry of Tourism and Wildlife</h5>
        <h5 className="text-center">National Tourism Service Portal</h5>
        <h5 className="text-center">Product/Packages Report</h5>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Code</th>
              <th scope="col">Region/Circuit </th>
              <th scope="col">County</th>
              <th scope="col">Name</th>
              <th scope="col">Status</th>
              <th scope="col">Category</th>
            </tr>
          </thead>
          <tbody>
            {state.map((k) => {
              return (
                <tr>
                  <td>{k.code}</td>
                  <td>{k.region}</td>
                  <td>{k.county}</td>
                  <td>{k.name}</td>
                  <td>{k.status}</td>
                  <td>{k.category}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="4">DATE: {convertTimestampToDate(Date.now())} </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div className="col-sm-2"></div>
    </div>
  ));
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: printRef, // ✅ new API for v3+
    documentTitle: "My PDF Document",
  });
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Product/Packages Report</li>
      </ol>
      <h1 class="page-header mb-3">Product/Packages Report</h1>
      <div style={{ backgroundColor: "white" }}>
        <hr />

        <div className="col-sm-12">
          <div className="row">
            <div className="col-sm-3">
              <button
                onClick={handlePrint}
                style={{
                  padding: "10px 15px",
                  background: "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                }}
              >
                Print to PDF
              </button>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-sm-5">
              <div className="form-group">
                <label htmlFor="statusId" className="font-weight-bold">
                  Select Region:
                </label>
                <select
                  className="form-control"
                  name="regionId"
                  required
                  value={inputs.regionId || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Region</option>
                  {regionsOptions &&
                    regionsOptions.map((regions) => (
                      <option key={regions.regionId} value={regions.regionId}>
                        {regions.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="countyId" className="font-weight-bold">
                  Select County:
                </label>
                <select
                  className="form-control"
                  name="countyId"
                  required
                  value={inputs.countyId || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select County</option>
                  {countiesOptions &&
                    countiesOptions.map((ward) => (
                      <option key={ward.countyId} value={ward.countyId}>
                        {ward.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="form-group">
                <label htmlFor="countyId" className="font-weight-bold">
                  Select Status:
                </label>
                <select
                  className="form-control"
                  name="statusId"
                  required
                  value={inputs.statusId || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Status</option>
                  {statusOptions &&
                    statusOptions.map((ward) => (
                      <option key={ward.statusId} value={ward.id}>
                        {ward.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-sm-1">
              <div className="form-group">
                <button
                  onClick={loadData}
                  style={{
                    padding: "10px 15px",
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    marginTop: "20px",
                    borderRadius: "6px",
                  }}
                >
                  Load
                </button>
              </div>
            </div>
          </div>
          <br />
          {state.length > 0 ? (
            <div ref={printRef}>
              <MyComponentToPrint ref={printRef} />
            </div>
          ) : null}
        </div>

        <h3>{responsemessage}</h3>
      </div>
    </div>
  );
};
export default ProductsReport;
